import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { ArrowRight, Sparkles } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function Hero() {
  return (
    <section className="relative overflow-hidden bg-radial-brand">
      {/* Background grid sutil */}
      <div
        className="absolute inset-0 bg-[linear-gradient(to_right,rgba(255,255,255,0.04)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.04)_1px,transparent_1px)] bg-[size:40px_40px] [mask-image:radial-gradient(ellipse_at_center,black_30%,transparent_70%)]"
        aria-hidden
      />

      <div className="container relative py-24 md:py-32 lg:py-40">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          className="max-w-3xl"
        >
          <div className="inline-flex items-center gap-2 rounded-full border border-brand-cyan/40 bg-brand-cyan/5 px-3 py-1 text-xs font-medium text-brand-cyan mb-6">
            <Sparkles className="size-3.5" />
            Consultoria em TI · Engenharia de Software · Treinamentos
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold leading-[1.05] tracking-tight text-balance">
            O mundo digital requer{' '}
            <span className="text-brand-gradient">soluções de valor</span>
          </h1>

          <p className="mt-6 text-lg md:text-xl text-muted-foreground max-w-2xl text-pretty">
            Com excelência e foco no cliente, fazemos isso acontecer. Arquitetura, squad as a service,
            infraestrutura cloud e formação de novos talentos.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <Button asChild size="lg">
              <Link to="/contato">
                Falar com a gente <ArrowRight className="size-4" />
              </Link>
            </Button>
            <Button asChild size="lg" variant="outline">
              <Link to="/cases">Ver cases</Link>
            </Button>
          </div>
        </motion.div>

        {/* Stats row */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8 max-w-3xl"
        >
          {[
            { value: '15+', label: 'anos de experiência' },
            { value: '14+', label: 'projetos entregues' },
            { value: '10+', label: 'clientes atendidos' },
            { value: '24h', label: 'suporte quando precisa' },
          ].map((s) => (
            <div key={s.label} className="border-l-2 border-brand-cyan/50 pl-4">
              <div className="text-3xl md:text-4xl font-bold text-foreground">{s.value}</div>
              <div className="text-xs uppercase tracking-wider text-muted-foreground mt-1">{s.label}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  )
}
